import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tabs: [],
  loading: false,
  error: null,
  RoutePathNames: [],
};

const tabsDataSlice = createSlice({
  name: 'tabs_data',
  initialState,
  reducers: {
    setTabs: (state, action) => {
      state.tabs = action.payload;
    },
    addTab: (state, action) => {
      state.tabs.push(action.payload);
    },
    removeTab: (state, action) => {
      state.tabs = state.tabs.filter((tab) => tab.id !== action.payload);
    },
    updateTab: (state, action) => {
      const { id, updates } = action.payload;
      const tabIndex = state.tabs.findIndex((tab) => tab.id === id);
      if (tabIndex !== -1) {
        state.tabs[tabIndex] = { ...state.tabs[tabIndex], ...updates };
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearTabs: (state) => {
      state.tabs = [];
      state.error = null;
    },
    setRoutePathNames: (state, action) => {
      state.RoutePathNames = action.payload;
    },
  },
});

export const {
  setTabs,
  addTab,
  removeTab,
  updateTab,
  setLoading,
  setError,
  clearTabs,
  setRoutePathNames,
} = tabsDataSlice.actions;

export default tabsDataSlice.reducer;
